import { render } from "./ArchivedProjects.vue?vue&type=template&id=e480f268&scoped=true"
import script from "./ArchivedProjects.vue?vue&type=script&lang=js"
export * from "./ArchivedProjects.vue?vue&type=script&lang=js"

import "./ArchivedProjects.vue?vue&type=style&index=0&id=e480f268&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e480f268"]])

export default __exports__